import React, { useEffect, useContext } from 'react'
import { Route, Routes } from 'react-router-dom'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import ReactPixel from 'react-facebook-pixel'
import Geocode from 'react-geocode'
import './App.css'
import StatusPayments from './components/Checkout/StatusPayments'
import ProtectedRoute from './components/ProtectedRoute'
import { VideoChat } from './components/TwilioVideo/VideoChat'
import { initSentry } from './lib/sentry'
import { Home } from './pages'
import BeAMaker from './pages/BeAMaker/BeAMaker'
import PageNotFound from './pages/PageNotFound/PageNotFound'
import BeAViewer from './pages/BeAViewer/BeAViewer'
import BuyingVest from './pages/BuyingVest/BuyingVest'
import InvitationRequest from './pages/InvitationRequest/InvitationRequest'
import LivePreview from './pages/LivePreview/LivePreview'
import LiveRating from './pages/LiveRating/LiveRating'
import RegisterSteps from './pages/Maker/Register/RegisterSteps'
import Part from './pages/Offers/Part'
import Pro from './pages/Offers/Pro'
import Payments from './pages/Payments/Payments'
import CreateRequests from './pages/Requests/CreateRequests'
import ServiceRating from './pages/ServiceRating/ServiceRating'
import ViewerAccount from './pages/ViewerAccount/ViewerAccount'
import ReactGa from 'react-ga4'
import config from './config'
import EndLIve from './pages/EndLive/EndLIve'
import { navigation, verifySession } from './utils/Utils'
import LiveContext from './components/Context/LiveContext'
import jwtDecode from 'jwt-decode'
import { useNavigate } from 'react-router-dom'

let vh = window.innerHeight * 0.01
document.documentElement.style.setProperty('--vh', `${vh}px`)

window.addEventListener('resize', () => {
  document.documentElement.style.setProperty(
    '--doc-height',
    `${window.innerHeight}px`
  )

  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})

initSentry()
const advancedMatching = {} // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
}

export default function App() {
  const { setUserLogged, setIdWatcher } = useContext(LiveContext)

  navigation.navigate = useNavigate()

  useEffect(() => {
    ReactGa.initialize(config.GA_MESURE_ID)
    ReactGa.send(window.location.pathname + window.location.search)
    ReactPixel.init('1396400911103581', advancedMatching, options)

    Geocode.setApiKey(config.GOOGLE_APP_KEY)
    Geocode.setLanguage('fr')
    Geocode.setRegion('fr')

    if (localStorage.getItem('access_token')) {
      setIdWatcher(jwtDecode(localStorage.getItem('access_token')).sub)
    }

    verifySession().then(
      (response) => {
        if (response && localStorage.getItem('access_token')) {
          setUserLogged(true)
        } else {
          setUserLogged(false)
        }
      },
      (err) => {
        setUserLogged(false)
        console.log(err)
      }
    )
  }, [])

  return (
    <div className="app">
      <Routes>
        {/* public routes */}
        <Route exact path="/" element={<Home />} />
        <Route exact path="/be-a-viewer" element={<BeAViewer />} />
        <Route exact path="/be-a-maker" element={<BeAMaker />} />
        <Route exact path="/register-maker/*" element={<RegisterSteps />} />
        <Route exact path="/pro" element={<Pro />} />
        <Route exact path="/particulier" element={<Part />} />
        <Route exact path="/create-request" element={<CreateRequests />} />
        <Route exact path="/payments" element={<Payments />} />
        <Route exact path="/payments-status" element={<StatusPayments />} />
        <Route
          exact
          path="/requests/:requestId"
          element={<InvitationRequest />}
        />
        <Route path="*" element={<PageNotFound />} />

        {/* protect these routes */}
        <Route
          path="/buying-vest"
          element={
            <ProtectedRoute>
              <BuyingVest />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/*"
          element={
            <ProtectedRoute>
              <ViewerAccount />
            </ProtectedRoute>
          }
        />
        <Route
          path="/end-live"
          element={
            <ProtectedRoute>
              <EndLIve />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <PageNotFound />
            </ProtectedRoute>
          }
        />
        <Route
          path="/live-preview"
          element={
            <ProtectedRoute>
              <LivePreview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/live"
          element={
            <ProtectedRoute>
              <VideoChat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/live-rating/:liveId"
          element={
            <ProtectedRoute>
              <LiveRating />
            </ProtectedRoute>
          }
        />
        <Route
          path="/service-rating"
          element={
            <ProtectedRoute>
              <ServiceRating />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  )
}
